// @flow
import * as React from 'react'
import { withRouter } from 'react-router-dom'
import MapToolbarStyles from 'catena/er2_styles/map_toolbar'
import * as ids from '../constants/ids'
import MapToolbarItem from './map_toolbar_item'
import GeoBar from './geo_bar'
import type GeoBarType from './geo_bar'

type Props = {
    geoBar: GeoBarType,
    geoBarIsActive?: Function,
    mapToolbar: {
        items: Array<{
            active: boolean,
            id: string,
            name: string,
        }>,
        isContracted: boolean,
        panel: { visible: boolean }
    },
    theme: MapToolbarStyles,
    onClickMapToolbarItem: Function,
    onClickGeoBarItem: Function,
}

export const geoBarIsActive = (mapToolbarProps, geoBarProps) => {
    const userLayersItem = mapToolbarProps.items.find(item => item.id === ids.MAP_TOOLBAR_USER_LAYERS)
    if (userLayersItem && userLayersItem.active) {
        const geoBarItem = geoBarProps.components.find(item => item.id === ids.GEO_BAR_HOME)
        return geoBarItem && geoBarItem.active
    }
    return false
}

function generateClassNames(props) {
    // Use the given theme if provided (don't try to merge,
    // since there's no guarantee the styles were build with Aphrodite)
    return `${props.theme.mapToolbar}
        ${props.mapToolbar.isContracted ? props.theme.contracted : ''}
        ${props.mapToolbar.panel.visible ? props.theme.noBoxShadow : ''}`
}

function MapToolbar(props: Props) {
    const renderedTheme = props.theme
    const classNames = generateClassNames(props)
    const hasGeoBar = props.geoBar && props.geoBar.enabled
    const activeIcon = props.mapToolbar.items.find(item => item.active)

    return (
        <div className={classNames}>
            <div className={renderedTheme.mapToolbarTop}>
                {activeIcon &&
                <div className={renderedTheme.mapToolbarSpacer}>
                    <div className={renderedTheme.iconCtr}>
                        {activeIcon.content ? activeIcon.content : <i className={activeIcon.icon.default} aria-hidden="true" title={activeIcon.name} /> }
                    </div>
                </div>
                }
                {!activeIcon &&
                <div className={renderedTheme.mapToolbarSpacer}>
                    <div className={renderedTheme.iconCtr}>
                        {<i className={'fa fa-globe'} aria-hidden="true" title="catena" />}
                    </div>
                </div>
                }
                {props.mapToolbar.items.filter(item => !item.position).map((item, idx) => (
                    <MapToolbarItem
                        key={item.id}
                        idx={idx}
                        item={item}
                        // Inject the theme to child components if provided
                        theme={renderedTheme}
                        onClick={props.onClickMapToolbarItem}
                    />),
                )}
            </div>
            <div className={renderedTheme.mapToolbarBottom}>
                {props.mapToolbar.items.filter(item => item.position === 'bottom').map((item, idx) => (
                    <MapToolbarItem
                        key={item.id}
                        idx={idx}
                        item={item}
                        // Inject the theme to child components if provided
                        theme={renderedTheme}
                        onClick={props.onClickMapToolbarItem}
                    />),
                )}
            </div>
            {hasGeoBar &&
            <GeoBar
                geoBar={props.geoBar}
                geoBarIsActive={props.geoBarIsActive || geoBarIsActive}
                mapToolbar={props.mapToolbar}
                onClickItem={props.onClickGeoBarItem}
                theme={props.theme}
            />
            }
        </div>
    )
}

MapToolbar.defaultProps = {
    geoBarIsActive: false,
}

export default withRouter(MapToolbar)
